import React, { FC } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import WebPosAppLoaderModel from 'webPosApp/models/shared/LoaderModel';
import KioskAppLoaderModel from 'webPosApp/models/shared/LoaderModel';

interface LoaderProps {
    loader: WebPosAppLoaderModel | KioskAppLoaderModel;
}

export const Loader: FC<LoaderProps> = observer(({ loader }) => {
    const className = classNames('loader', {
        'loader--is-open': loader.isOpen,
    });

    return (
        <div className={className}>
            <div className='loader__center'>
                <div className='loader__icon'></div>
                <span className='loader__title'>{loader.text}</span>
            </div>
        </div>
    );
});
